import FirstLegalRepresentativePage from '@/pages/child/FirstLegalRepresentativePage.vue';
import FirstLegalRepresentativePersonalInfoPage from '@/pages/child/FirstLegalRepresentativePersonalInfoPage.vue';
import FirstLegalRepresentativeIdentityVerificationPage from '@/pages/child/FirstLegalRepresentativeIdentityVerificationPage.vue';
import FirstLegalRepresentativeAddressPage from '@/pages/child/FirstLegalRepresentativeAddressPage.vue';
import ChildPersonalInfoPage from '@/pages/child/ChildPersonalInfoPage.vue';
import ChildAddressPage from '@/pages/child/ChildAddressPage.vue';
import AuthorizedPersonIdentityVerificationPage from '../pages/child/AuthorizedPersonIdentityVerificationPage.vue';

export default [
  {
    name: 'Step6Child',
    path: '/osobne-udaje-dieta',
    component: ChildPersonalInfoPage,
    meta: {
      pathEN: '/osobne-udaje-dieta',
      pathUA: '/osobne-udaje-dieta',
      pathRU: '/osobne-udaje-dieta',
      step: 10,
      icon: 'todo',
      labelSK: 'Osobne udaje dieta',
      labelEN: 'Osobne udaje dieta',
      labelUA: 'Osobne udaje dieta',
      labelRU: 'Osobne udaje dieta',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
  {
    name: 'Step7Child',
    path: '/udaje-o-pobyte-dietata',
    component: ChildAddressPage,
    meta: {
      pathEN: '/udaje-o-pobyte-dietata',
      pathUA: '/udaje-o-pobyte-dietata',
      pathRU: '/udaje-o-pobyte-dietata',
      step: 11,
      icon: 'todo',
      labelSK: 'Udaje o pobyte dietata',
      labelEN: 'Udaje o pobyte dietata',
      labelUA: 'Udaje o pobyte dietata',
      labelRU: 'Udaje o pobyte dietata',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
  {
    name: 'Step8Child',
    path: '/zakonny-zastupca-dieta',
    component: FirstLegalRepresentativePage,
    meta: {
      pathEN: '/zakonny-zastupca',
      pathUA: '/zakonny-zastupca',
      pathRU: '/zakonny-zastupca',
      step: 12,
      icon: 'todo',
      labelSK: 'Zakonny zastupca',
      labelEN: 'Zakonny zastupca',
      labelUA: 'Zakonny zastupca',
      labelRU: 'Zakonny zastupca',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
  {
    name: 'Step9Child',
    path: '/osobne-udaje-zakonny-zastupca',
    component: FirstLegalRepresentativePersonalInfoPage,
    meta: {
      pathEN: '/osobne-udaje-zakonny-zastupca',
      pathUA: '/osobne-udaje-zakonny-zastupca',
      pathRU: '/osobne-udaje-zakonny-zastupca',
      step: 13,
      icon: 'todo',
      labelSK: 'Osobné údaje',
      labelEN: 'Osobné údaje',
      labelUA: 'Osobné údaje',
      labelRU: 'Osobné údaje',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
  {
    name: 'Step10Child',
    path: '/overenie-totoznosti-splnomocnenej-osoby',
    component: AuthorizedPersonIdentityVerificationPage,
    meta: {
      pathEN: '/overenie-totoznosti-splnomocnenej-osoby',
      pathUA: '/overenie-totoznosti-splnomocnenej-osoby',
      pathRU: '/overenie-totoznosti-splnomocnenej-osoby',
      step: 14,
      icon: 'todo',
      labelSK: 'Overenie totoznosti',
      labelEN: 'Overenie totoznosti',
      labelUA: 'Overenie totoznosti',
      labelRU: 'Overenie totoznosti',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
  {
    name: 'Step11Child',
    path: '/overenie-totoznosti-zakonny-zastupca',
    component: FirstLegalRepresentativeIdentityVerificationPage,
    meta: {
      pathEN: '/overenie-totoznosti-zakonny-zastupca',
      pathUA: '/overenie-totoznosti-zakonny-zastupca',
      pathRU: '/overenie-totoznosti-zakonny-zastupca',
      step: 15,
      icon: 'todo',
      labelSK: 'Overenie totoznosti',
      labelEN: 'Overenie totoznosti',
      labelUA: 'Overenie totoznosti',
      labelRU: 'Overenie totoznosti',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
  {
    name: 'Step12Child',
    path: '/udaje-o-pobyte-zakonneho-zastupcu',
    component: FirstLegalRepresentativeAddressPage,
    meta: {
      pathEN: '/udaje-o-pobyte',
      pathUA: '/udaje-o-pobyte',
      pathRU: '/udaje-o-pobyte',
      step: 16,
      icon: 'todo',
      labelSK: 'Udaje o pobyte',
      labelEN: 'Udaje o pobyte',
      labelUA: 'Udaje o pobyte',
      labelRU: 'Udaje o pobyte',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'CHILD',
    },
  },
];
